import {
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_FAILURE,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_CLEAR,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_REQUEST,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_FAILURE,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_CLEAR,
  FETCH_KEG_COLLECTION_BOOKINGS_LIST_VIEW_SEARCH_FILTER_OPTIONS_QUEUE
)
